import React from 'react';
// import Header from '../components/Header';
// import homeBg from '../assets/home-bg.png'

const Home = () => {

    const handleClick = () => {
        window.open("https://magid.com/emotional-dna/");
      };

    return (

        <div className="bg-[url(/src/assets/home-bg.png)] bg-cover w-screen h-screen fixed overflow-auto pb-40">
        {/* <div> */}
            {/* <div className='bg-white bg-opacity-10 h-screen -mt-12'> */}
            {/* <Header /> */}
            <div className='mt-64 text-center md:text-left px-8 md:px-36 flex-inline justify-items-start'>
                <p className="-mt-8
                    text-5xl lg:text-9xl font-extrabold font-[Philosopher]
                              [text-shadow:10px_20px_16px_rgba(0,0,0,0.4)]
                             text-[#EFE0D5] drop-shadow-2xl  shadow-black" >emotionalDNA</p>
                <p className='mt-5
                              text-[33px] font-bold font-[Roboto]
                            text-white'>The solution to major entertainment business challenges</p>

                <p className='mt-12
                              text-[29px] font-[Roboto]
                            text-white'>Emotions are the heart of entertainment –</p>
                <p className='mt-0
                              text-[22px] font-light font-[Roboto]
                            text-white'>and understanding what compels action is the key to driving
                            <br/>consumer behavior.</p>

                <button className='my-4 w-100
                                   bg-[#EFE0D5] px-8 py-4 rounded-full
                                   text-[#BB16A3] font-extrabold text-lg
                                   hover:bg-[#512937] hover:text-white hover:font-bold'
                        onClick={handleClick}>
                    Read More</button>
            </div>
            {/* </div> */}
        </div>
     );
}

export default Home;
